<template>
  <el-link v-if="link" type="primary" @click="handelClick">{{ text }}</el-link>
  <ml-button v-else :text="text" :size="size" :round="round" :icon="icon" @click.native="handelClick" />
</template>
<script>
import { export_json_to_excel } from '@/utils/export/excel'
import { module_config } from './index.js'
import MlButton from '@/components/MlButton/index.vue'

export default {
  name: 'MlExportStatic',
  components: { MlButton },
  props: {
    module: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    filename: {
      type: String,
      default() {
        return ''
      }
    },
    size: {
      type: String,
      default() {
        return ''
      }
    },
    round: Boolean,
    link: Boolean,
    result: Boolean,
    icon: {
      type: String,
      default() {
        return 'el-icon-download'
      }
    },
    text: {
      type: String,
      default() {
        return '导出'
      }
    },
    // eslint-disable-next-line vue/require-default-prop
    pageSize: Number
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    /**
     * 开始导出
     * @returns {Promise<void>}
     */
    handelClick: async function() {
      const _this = this
      let tmpFieldMap = {}
      if (this.result) {
        tmpFieldMap = {
          '处理进度': 'do_status_alia',
          '处理结果': 'do_error'
        }
      }
      const { fields } = module_config[this.module]
      let sourceData = module_config[this.module].sourceData
      if (fields === undefined) {
        this.$message.error('下载异常！')
        return
      }

      const fieldMap = { ...tmpFieldMap, ...fields }
      sourceData = _this.data.length > 0 ? _this.data : (sourceData || [])

      export_json_to_excel(
        {
          fieldMap,
          sourceData,
          filename: _this.result ? '导入结果' : _this.filename ? `${_this.filename}` : (module_config[this.module].name || '下载'),
          mergeColumns: []
        })
    }
  }
}

</script>
<style lang="scss">
.export-by-page-container {
  display: inline;
}
</style>
